module.exports = __webpack_public_path__ + "webfolder/assets/ebook/ytt-magazine/issue-2/ar/img/guaranteed-origins-1200x630.1804e458.jpg";